<template>
    <div class="modal fade" :id="modalId">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span></button>
                    <h4 class="modal-title">{{title}}</h4>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default pull-left" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" @click="send">{{okText}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'confirm-modal',

    data() {
        return {

        }
    },

    props: {
        modalId: {
            type:String,
            required: true,
        },

        title: {
            type:String,
            default: ''
        },

        okText: {
            type:String,
            default: 'OK'
        }
    },

    created() {},

    mounted() {},

    methods: {
        send() {
            this.$emit("ok")
        }
    },

    components: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ConfirmModal.vue